module.exports = __webpack_public_path__ + "static/media/shelter_cave_marker.a05bb7ad.svg";